import React from 'react';
import { getPageStaticProps } from 'lib/dato-request';
import { ContactForm } from 'components/Contact/ContactForm';
import SecondaryPageLayout from '@/components/ReusableUI/SecondaryPageLayout';

const Contact = ({ data }) => {
    const { page } = data;
    const { components, seo } = page;
    return (
        <SecondaryPageLayout page={page} components={[components[1]]}>
            <ContactForm />
        </SecondaryPageLayout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('Contact');
}

export default Contact;
